/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Vänskapscentret",
      "Hitta nya vänner med Bumble For Friends | Bumble",
      "Ladda ned från App Store",
      "Hämta från Google Play",
      "En plats att träffa nya vänner",
      "Hitta personer nära dig som är här för att träffa äkta vänner.",
      "Hitta vänner för livets alla skeden",
      "Ny i stan? Redo för en omstart? Ditt nya gäng väntar på dig!",
      "En trygg plats för alla",
      "Välkommen till ett snällt hörn på internet där alla kan vara sig själva.",
      "Ladda ned appen",
      "Träffa personer med samma intressen IRL",
      "Lär känna en ny grupp människor med Plans på Bumble For Friends",
      "Du har blivit inbjuden till Plans",
      "Plans är en ny funktion på Bumble For Friends där du kan skapa och hänga med på gruppträffar med vänner nära dig",
      "Hantera cookies",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "dagar",
                  "dagars"
            ],
            "singular": [
                  "dag",
                  "dags"
            ]
      },
      "hour": {
            "plural": [
                  "timmar",
                  "timmars"
            ],
            "singular": [
                  "timme",
                  "timmes"
            ]
      },
      "minute": {
            "plural": [
                  "minuter",
                  "minuters"
            ],
            "singular": [
                  "minut",
                  "minuts"
            ]
      },
      "month": {
            "plural": [
                  "månader",
                  "månaders"
            ],
            "singular": [
                  "månad",
                  "månads"
            ]
      },
      "second": {
            "plural": [
                  "sekunder",
                  "sekunders"
            ],
            "singular": [
                  "sekund",
                  "sekunds"
            ]
      },
      "year": {
            "plural": [
                  "år",
                  "års"
            ],
            "singular": [
                  "år",
                  "års"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
